export default function Tabs() {
	// Get all tab intances
	const tabIntances = document.querySelectorAll('.js-tab-wrapper');

	if (tabIntances.length) {
		tabIntances.forEach(instance => {
			// Get all the tab parent elements
			const tabParents = instance.querySelectorAll('.js-tab-parent');

			tabParents.forEach(function(tabParent) {
				// Add event listener for each tab parent
				tabParent.addEventListener('click', function(event) {
					// Dispatch an event to possibly update other parts of the UI, e.g. accordion heights
					document.dispatchEvent(new Event('updateAccordionHeights'));

					// Get the unique key of the clicked tab parent to identify associated tab items
					const key = tabParent.getAttribute('data-key');

					// Deactivate all tab parents
					tabParents.forEach(function(parent) {
						parent.classList.remove('active');
					});

					// Activate the clicked tab parent
					tabParent.classList.add('active');

					// Get all tab items and activate the one that matches the clicked tab parent's key
					const tabItems = instance.querySelectorAll('.js-tab-item');
					tabItems.forEach(function(tabItem) {
						const itemKey = tabItem.getAttribute('data-key');
						if (itemKey === key) {
							tabItem.classList.add('active');
						} else {
							tabItem.classList.remove('active');
						}
					});
				});
			});
		});
	}
}
